module.exports = __webpack_public_path__ + "static/img/Round-02-2014.c1e4ae4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-02-2014.jpg
// module id = qaQr
// module chunks = 0